import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class HomeService extends ApiService {
	constructor() {
		super();
	}

	public sendPolicyChecks(body: Array<{ uuid: string; checked: boolean }>): Observable<any> {
		return this.http.post<any>(
			environment.identity2 + `/home/policy_checks`,
			{ checks: body },
			{ headers: this.getHeaders() },
		);
	}
}
